<template>
    <div>
        <h2>{{ accessoryFeatures.title }}</h2>
        <div class="row">
            <div
                v-for="(feature, index) in accessoryFeatures.technicalFeatures"
                :key="'technical-feeature-'+ index"
                class="mb-2 mb-md-3"
                :class="index === 0 ? 'col-12' : 'col-12 col-md-6'"
            >
                <p class="lead fw-bold mb-0">
                    {{ feature.title }}
                </p>
                <span class="text-mw standard" v-html="feature.text" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        accessoryFeatures: {
            type: Object,
            required: true,
        }
    }
}
</script>
